import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../LoginContainer/styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Divider from 'srcReact/components/common2/Divider'
import { useTranslation } from 'react-i18next'
import { TextBox } from '../../../components/common2/TextBox'
import { isEmail } from 'srcReact/helpers/validator'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { useDispatch } from 'react-redux'
import { loginActions } from 'srcReact/LoginPage/actions'
import Spinner from 'srcReact/components/common2/Spinner'
import { redirectToPage } from 'srcReact/helpers/history'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function Email({
  value,
  currentState,
  setCurrentState,
  setCurrentStep,
  isNative,
  loading,
  isRegistered,
  idps,
  organizations,
  workplaceInvitations
}) {
  const { t } = useTranslation()
  const [nextClicked, setNextClicked] = useState(false)
  const [emailRef, setEmailRef] = useState(null)
  const [errorFromSSO, setErrorFromSSO] = useState('')
  const [errorFromEmail, setErrorFromEmail] = useState('')

  const [email, setEmail] = useState({
    name: 'email',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (value) {
      setEmail({ ...email, value: value })
    }
    //This code is used when there is login mismatch in entered email and already logged in sso email/password
    if (localStorage.getItem('sso_error')) {
      setErrorFromSSO(localStorage.getItem('sso_error'))
      localStorage.removeItem('sso_error')
    }
  }, [])

  useEffect(() => {
    if (emailRef) {
      emailRef.current.focus()
    }
  }, [emailRef])

  const handleTextChange = (event) => {
    if (event) {
      const { value } = event.target
      setEmail({ ...email, value: value, hasError: false, errorMessage: '' })
    }
  }

  const validate = () => {
    const emailValue = email.value
    if (!emailValue) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.email`) })
      })
      return false
    } else if (!isEmail(emailValue)) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('error.invalid_email')
      })
      return false
    }
    return true
  }

  const handleNext = (e) => {
    e.preventDefault()
    setNextClicked(true)
    const isValid = validate()

    if (isValid) {
      setCurrentState({ ...currentState, email: email.value.toString() })
      dispatch(loginActions.checkEmail(email.value))
    }
  }

  useEffect(() => {
    if (nextClicked) {
      if (!loading && idps) {
        if (idps) {
          if (idps.length === 0) {
            if (isRegistered === 1) {
              setCurrentStep('password')
              return
            } else {
              //normal mixr registration
              // redirectToPage('/0/signup?step=email')
              setErrorFromEmail(t('login.emailNotFound'))
              return
            }
          }
          if (idps.length > 1) {
            //if contains both SSO org and mixr orgs
            setCurrentStep('org-selection')
          } else {
            if (idps[0].type === 'mixr') {
              if (isRegistered === 1) {
                //normal mixr login
                setCurrentStep('password')
              } else {
                //normal mixr registration
                // redirectToPage('/0/signup?step=email')
                setErrorFromEmail(t('login.emailNotFound'))
              }
            } else {
              //external SSO
              if (organizations && organizations.length === 1) {
                localStorage.setItem('ssoOrgId', organizations[0].id)
              }
              localStorage.setItem('ssoEmail', email.value)
              window.location = idps[0].login_url
            }
          }
        }
        setNextClicked(false)
      }
    }
  }, [idps, loading])

  return (
    <div className={styles.emailContainer}>
      <h1 className={parentStyles.title}>{t('login.email.title')}</h1>
      <h2 className={parentStyles.subTitle}>{t('login.email.subTitle')}</h2>
      <form name='emailForm' className={styles.form} onSubmit={handleNext}>
        {errorFromSSO && <ErrorMessage text={errorFromSSO} className={styles.error} />}
        <TextBox
          label={t('formlabel.enterEmail')}
          inputType='text'
          isRequired={true}
          fieldInfo={email}
          onChange={handleTextChange}
          name='email'
          placeholder='e.g. John@mail.com'
          setRef={setEmailRef}
          customWrapperCss={styles.emailWrapper}
        />
        {errorFromEmail && <ErrorMessage html={errorFromEmail} className={styles.error} />}
        <div className={parentStyles.buttons}>
          <Button type='submit' text={t('global.btnNext')} customStyle={styles.nextBtn} />
          {loading && <Spinner customCss={styles.spinner} />}
        </div>
      </form>
      <Divider className={styles.divider} text={t('global.or')} />
      <footer>
        <AnchorLink className={styles.link} isNative={isNative} path='/0/signup'>
          {t('login.email.createOrgNow')}
        </AnchorLink>
      </footer>
    </div>
  )
}

export default Email
